import { ValidatorFn } from '@angular/forms';
import { BerthExistsValidator } from '@shared/validators/berth/exists';

export class U2bBerthValidators {
    public static berthExists(message?: string): ValidatorFn {
        return new BerthExistsValidator(message).asValidatorFn();
    }
}
